export default {
  sections: {
    address: 'Yrityksen osoite',
    address_help: 'Kirjoita osoite, jolle yrityksesi on rekisteröity. Se näkyy laskuissasi.',
  },
  form: {
    legal_form: {
      label: 'Yritysmuoto',
      help: 'UG (haftungsbeschränkt) vastaa tässä GmbH:ta, e.K. yksityistä elinkeinonharjoittajaa. OHG:n tai KG:n osalta ota yhteyttä tukeen.',
      options: {
        sole_trader: 'Yksityinen elinkeinonharjoittaja',
        gbr: 'GbR',
        gmbh: 'GmbH / UG',
      },
    },
    legal_name: {
      label: 'Rekisteröity yrityksen nimi',
      placeholder: 'Syötä rekisteröity yrityksen nimi',
      sole_trader_help: 'Jätä tyhjäksi, jos toimit omalla nimelläsi',
    },
  },
  buttons: {
    next: 'Seuraava',
  },
};
